import { ReactNode, Suspense } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import { ChunkLoadErrorBoundary, lazyChunk } from "@shared/ChunkLoadErrorBoundary";
import { SectionPanel } from "@shared/SectionPanel/SectionPanel";

import type { Props } from "./EventChartCard";
import { useStyles } from "./EventChartCard.styles";
import { EventChartCardLoading } from "./EventChartCardLoading";

const LazyEventChartCard = lazyChunk(() => import("./EventChartCard").then((module) => ({ default: module.EventChartCard })));

const EventChartCardShell = ({ children }: { children: ReactNode }) => {
    const { classes } = useStyles();
    const { t } = useTranslation("pages");

    return (
        <SectionPanel className={classes.card} title={t("overviewPage.cards.eventChart.title")}>
            {children}
        </SectionPanel>
    );
};

const EventChartCardLoadFailed = () => {
    const { classes } = useStyles();
    const { t } = useTranslation("common");

    return (
        <EventChartCardShell>
            <Typography align="center" color="error" className={classes.noActivityText}>
                {t("error.failedToLoadFeature")}
            </Typography>
        </EventChartCardShell>
    );
};

export const EventChartCard = (props: Props) => (
    <ChunkLoadErrorBoundary fallback={<EventChartCardLoadFailed />}>
        <Suspense
            fallback={
                <EventChartCardShell>
                    <EventChartCardLoading />
                </EventChartCardShell>
            }
        >
            <LazyEventChartCard {...props} />
        </Suspense>
    </ChunkLoadErrorBoundary>
);
